import { render, staticRenderFns } from "./PropertyItems.vue?vue&type=template&id=0290df19"
import script from "./PropertyItems.vue?vue&type=script&lang=js"
export * from "./PropertyItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports